module.exports = __webpack_public_path__ + "img/5.22dedc50.png";